"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AspectRatio = AspectRatio;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const _excluded = ["width", "height", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const AspectRatioContainer = _styledComponents.default.div`
  position: relative;
  &:before {
    display: block;
    content: '';
    width: 100%;
    padding-top: ${props => props.height / props.width * 100}%;
  }
`;
const AspectRatioContent = _styledComponents.default.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
function AspectRatio(_ref) {
  let {
      width,
      height,
      children
    } = _ref,
    next = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(AspectRatioContainer, _extends({
    width: width,
    height: height
  }, next), /*#__PURE__*/_react.default.createElement(AspectRatioContent, null, children));
}
AspectRatio.propTypes = {
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  children: _propTypes.default.node
};
AspectRatio.defaultProps = {
  children: []
};
var _default = exports.default = AspectRatio;
//# sourceMappingURL=AspectRatio.js.map